import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation"; // optional if AOS is in RootLayout
import RootLayout from "./layout";
import early from "../assets/images/activity/early.jpg";
import primary from "../assets/images/activity/primary.jpg";
import middle from "../assets/images/activity/middle.jpg";



const ScholasticProgram = () => {
  return (
    <>
      <RootLayout>
        {/* If you've moved AOS.init to RootLayout, you can remove this: */}
        <Animation />

        <HeaderOne />
        <Breadcrumb title={"Scholastic Program"} />

        <section className="join-community">
          <div className="container container--lg">
            <div className="rounded-20 py-60 px-8">
              <div className="container">
                {/* Intro */}
                <div className="row gy-4 align-items-center">
                  <div className="col-lg-12">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h2
                          className="mb-24"
                          data-aos="fade-up"
                          data-aos-duration="800"
                        >
                          Scholastic Program
                        </h2>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-duration="800"
                          data-aos-delay="120"
                        >
                          Teaching students how to learn is just as important as
                          teaching them what to learn. We encourage our students
                          to think for themselves, ask questions and pursue
                          their interests through independent reading and
                          research.
                          <br />
                          <br />
                          The curriculum is regularly updated to stimulate
                          students’ interests and gain the knowledge they need
                          to compete in the fast-changing 21st century global
                          world. Teachers strive to make the classes as
                          interactive as possible and use different methods to
                          get the best out of each student. Collaborative
                          learning is incorporated into lessons so students can
                          share ideas and learn with and from each other.
                          <br />
                          <br />
                          Students are engaged in experiential learning through
                          a variety of resources. Visual Arts, Music, Dance,
                          Yoga and Physical Education are additional curricular
                          offerings to all students. There are also many
                          enrichment activities including outbound trips and
                          exchanges with other schools.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Early Years */}
                <div className="row gy-4 align-items-center" id="early">
                  <div className="col-lg-8">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          Early Years
                        </h3>
                        <h4 data-aos="fade-up" data-aos-delay="80">
                          Montessori
                        </h4>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          Our <b>Montessori schools</b> near you offer a
                          scholastic program that provides a unique and
                          effective approach to education for children aged
                          three and up. Founded in 1907 by Dr. Maria Montessori,
                          the Montessori method is based on self-directed
                          activity, hands-on learning, and collaboration.
                          <br />
                          <br />
                          In our Montessori environment, mixed-age groups
                          promote a strong sense of community through peer
                          learning and interaction. Children have the freedom to
                          move around and choose from a variety of
                          developmentally appropriate activities under the
                          guidance of trained adults. If you’re looking for a
                          supportive learning environment that fosters your
                          child’s natural curiosity, search for{" "}
                          <b>“Montessori near me”</b> or
                          <b>“Montessori schools near me”</b> and schedule a
                          visit.
                        </p>
                        <br />
                        <br />
                        <h4 data-aos="fade-up" data-aos-delay="80">
                          Kindergarten
                        </h4>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          Children join Kindergarten at four years of age and
                          continue for two years until Class 1. It promotes
                          holistic development essential for continuous success
                          in school life in student-centred settings. Children
                          participate in activities which weave arts, crafts,
                          stories and play together to explore a range of
                          concepts in language, mathematics and sciences. Each
                          Kindergarten class is supported by two teachers,
                          improving the student–teacher ratio.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-lg-4"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="join-community__thumb text-end position-relative">
                      <img
                        src={early}
                        alt="NPS Kudlu Students"
                        className="img-fluid rounded-12"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>

                {/* Primary Years — image left on desktop, first on mobile if desired */}
                <div className="row gy-4 mt-2 align-items-center" id="primary">
                  {/* Image */}
                  <div
                    className="col-lg-4 order-1 order-lg-1"
                    data-aos="zoom-in"
                  >
                    <div className="join-community__thumb text-end position-relative">
                      <img
                        src={primary}
                        alt="NPS Kudlu Classrooms"
                        className="img-fluid rounded-12"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  {/* Text */}
                  <div className="col-lg-8 order-2 order-lg-2">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          Primary Years
                        </h3>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          <b>NPS Kudlu</b> is one of the{" "}
                          <b>Best CBSE schools in Bangalore</b> that offers an
                          integrated, interdisciplinary curriculum for Primary
                          school students. Our academically rigorous curriculum
                          is presented imaginatively, engaging students
                          physically, cognitively, and emotionally while also
                          incorporating creative arts.
                          <br />
                          <br />
                          We facilitate learning through activity-oriented
                          lessons, hands-on work, and extensive co-curricular
                          activities. Following CBSE norms, we have a ‘No
                          Homework’ policy for Classes 1 and 2.
                          <br />
                          <br />
                          As students progress, we introduce them to integrated
                          knowledge in core subjects such as English,
                          Mathematics, General Science, and Social Science.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Middle Years */}
                <div className="row gy-4 mt-2 align-items-center" id="middle">
                  {/* Text */}
                  <div className="col-lg-8">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          Middle Years
                        </h3>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          <b>NPS Kudlu</b> is one of the{" "}
                          <b>Top CBSE Schools in Bangalore</b> that offers a
                          broad-based curriculum with emphasis on core subjects
                          for Middle School students.
                          <br />
                          <br />
                          In Class 5, we focus on English, Mathematics, Computer
                          Science, Hindi, Kannada, General Science, and Social
                          Studies. In Classes 6 & 7, Mathematics is split into
                          Math-I and Math-II; General Science becomes Physics,
                          Chemistry, and Biology; and Social Science specializes
                          into History-Civics and Geography. English, Hindi,
                          Kannada, and Computer Science continue to be integral.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Image */}
                  <div className="col-lg-4" data-aos="zoom-in">
                    <div className="join-community__thumb text-end position-relative">
                      <img
                        src={middle}
                        alt="Smart Classroom"
                        className="img-fluid rounded-12"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /container */}
            </div>
          </div>
        </section>

        <FooterThree />
      </RootLayout>
    </>
  );
};

export default ScholasticProgram;
